import React from "react";
import { useTranslation } from "react-i18next";
import { useConfigurator } from "../context/ConfiguratorContext";
import TractorSidebar from "./TractorSidebar";
import Utils from "../utils";

const TractorEquiment = ({ setCurrentStep }) => {
  const { t } = useTranslation();

  const { setSelectedEquipment, selectedEquipment, tractorEquimentList } =
    useConfigurator();

  const handleSelectedTractorUpgrade = (item) => {
    setSelectedEquipment((prevSelected) => {
      const isAlreadySelected = prevSelected.some(
        (tire) => tire.id === item.id
      );

      if (isAlreadySelected) {
        return prevSelected.filter((tire) => tire.id !== item.id);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleBack = () => {
    setCurrentStep(4);
  };

  const handleNext = () => {
    setCurrentStep(6);
  };

  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-lg-9">
          <div className="card bg-card">
            <div className="card-body">
              <div className="row mb-4">
                <div className="col-12">
                  <h4 className="tractor-heading-main mb-4">
                    {t("chooseYourTractorEquipment")}
                  </h4>
                </div>
              </div>
              <div className="tractor-scroll-container custom-scrollbar ">
                <div className="row">
                  {tractorEquimentList && tractorEquimentList.length > 0 ? (
                    tractorEquimentList.map((tractor, index) => (
                      <div key={index} className="mb-4">
                        {tractor?.group_name && (
                          <h3 className="text-xl fw-semibold text-dark border-bottom pb-2 mb-3">
                            {tractor?.group_name}
                          </h3>
                        )}

                        <div className="row">
                          {tractor?.list?.map((item) => (
                            <div
                              className="col-md-6 col-xl-4 equal-height"
                              key={item.id}
                            >
                              <div
                                className={`card custom-card custom-card-choose ${
                                  selectedEquipment.some(
                                    (tire) => tire.id === item.id
                                  )
                                    ? `active`
                                    : ``
                                }`}
                                onClick={() =>
                                  handleSelectedTractorUpgrade(item)
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <div className="position-relative bg-light-gry">
                                  <img
                                    src={item?.image}
                                    className="card-img-top tires-img"
                                    alt={item?.name}
                                  />
                                </div>
                                <div className="card-body">
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div className="card-price mb-0">
                                      {item?.is_price_included === 1
                                        ? t(`free`)
                                        : Utils.priceNumberFormat(item.price)}
                                    </div>
                                    {item?.is_price_included === 1 && (
                                      <div className="card-price mb-0">
                                        <span className="badge bg-light text-dark border inc-width">
                                          {t("included")}
                                        </span>
                                      </div>
                                    )}
                                  </div>

                                  <h6 className="card-title card-title-custom">
                                    {item.name}
                                  </h6>
                                  <div
                                    className="card-text small card-nav"
                                    dangerouslySetInnerHTML={{
                                      __html: item.detail,
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className={`col-md-12 d-flex justify-content-center`}>
                      {t("NoEquipmentAvailable")}.
                    </div>
                  )}{" "}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3 mt-4 mt-lg-0">
          <div className="total-price-box-tires">
            <TractorSidebar />
          </div>

          <div className="d-flex justify-content-between mt-3">
            <button
              className="btn btn-outline-theme tractor-custom-button-details"
              onClick={handleBack}
            >
              <i className="bi bi-arrow-left me-2"></i>
              {t("back")}
            </button>
            <button
              className="btn btn-danger tractor-custom-button-details"
              onClick={handleNext}
            >
              {t("next")}
              <i className="bi bi-arrow-right ms-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TractorEquiment;
